import { render, staticRenderFns } from "./Widget.vue?vue&type=template&id=f09abe7e&scoped=true&"
import script from "./Widget.vue?vue&type=script&lang=js&"
export * from "./Widget.vue?vue&type=script&lang=js&"
import style0 from "./Widget.vue?vue&type=style&index=0&id=f09abe7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09abe7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VIcon})
